import { render } from "./newsDetails.vue?vue&type=template&id=1103d1be&scoped=true"
import script from "./newsDetails.vue?vue&type=script&lang=js"
export * from "./newsDetails.vue?vue&type=script&lang=js"

import "../../../styles/editor.css?vue&type=style&index=0&id=1103d1be&scoped=true&lang=css"
import "./newsDetails.vue?vue&type=style&index=1&id=1103d1be&scoped=scoped&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1103d1be"]])

export default __exports__